import { useState, useEffect, useCallback } from 'react';
import { useSelector } from 'react-redux';
import RecordingService from '../services/recordingService';

export const useRecordings = () => {
  const user = useSelector((state) => state.auth.user);
  const [recordings, setRecordings] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [pagination, setPagination] = useState({
    page: 0,
    size: 20,
    totalElements: 0,
    totalPages: 0
  });

  const fetchRecordings = useCallback(async (page = 0, size = 20) => {
    if (!user) return;

    setLoading(true);
    setError(null);

    try {
      console.log('🔍 useRecordings - Fetching recordings for user:', user);
      console.log('🔍 useRecordings - User roles:', user.roles);
      console.log('🔍 useRecordings - User ID:', user.id);
      
      let response;
      const userRole = user.roles?.[0]; // Get first role
      
      console.log('🔍 useRecordings - Determined user role:', userRole);
      
      // Use the consolidated recording service
      // The service handles the role-aware backend endpoint
      console.log('🔍 useRecordings - Using RecordingService');
      response = await RecordingService.getRecordings(page, size);

      console.log('🔍 useRecordings - Raw API Response:', response);
      console.log('🔍 useRecordings - Response content:', response?.content);
      console.log('🔍 useRecordings - Response content length:', response?.content?.length);
      console.log('🔍 useRecordings - Response totalElements:', response?.totalElements);
      
      const recordingsList = response.content || [];
      console.log('🔍 useRecordings - Final recordings list:', recordingsList);
      
      setRecordings(recordingsList);
      setPagination({
        page: response.number || 0,
        size: response.size || 20,
        totalElements: response.totalElements || 0,
        totalPages: response.totalPages || 0
      });
    } catch (err) {
      console.error('🔍 useRecordings - Error fetching recordings:', err);
      console.error('🔍 useRecordings - Error details:', err.response?.data);
      setError(err.message || 'Failed to fetch recordings');
      setRecordings([]);
    } finally {
      setLoading(false);
    }
  }, [user]);

  useEffect(() => {
    fetchRecordings();
  }, [fetchRecordings]);

  const refreshRecordings = useCallback(() => {
    fetchRecordings(pagination.page, pagination.size);
  }, [fetchRecordings, pagination.page, pagination.size]);

  const changePage = useCallback((newPage) => {
    fetchRecordings(newPage, pagination.size);
  }, [fetchRecordings, pagination.size]);

  const changePageSize = useCallback((newSize) => {
    fetchRecordings(0, newSize);
  }, [fetchRecordings]);

  return {
    recordings,
    loading,
    error,
    pagination,
    fetchRecordings,
    refreshRecordings,
    changePage,
    changePageSize
  };
};